import { getName, getNames, registerLocale } from 'i18n-iso-countries'
import enLocale from 'i18n-iso-countries/langs/en.json'
// import esLocale from 'i18n-iso-countries/langs/es.json'
// import frLocale from 'i18n-iso-countries/langs/fr.json'

export type LocalizedCountry = {
    alpha2Code: string
    title: string
    flagEmoji: string
}

export class LocalizedCountries {
    constructor() {
        registerLocale(enLocale)
        // registerLocale(esLocale)
        // registerLocale(frLocale)
    }

    get currentLocaleCode() {
        return 'en'
        // const store = useLocalizationStore()

        // let code = store.currentLocale.toLowerCase().split('-')[0]
        // code = getSupportedLanguages().includes(code) ? code : 'en'

        // return code
    }

    getAllCountries(): LocalizedCountry[] {
        const countryList = getNames(this.currentLocaleCode, { select: 'alias' })

        const countries = Object.entries(countryList).map(([alpha2Code, title]) => {
            return {
                alpha2Code,
                title,
                flagEmoji: this.emojiForCountryCode(alpha2Code)
            }
        })

        return countries
    }

    localizedCountryForAlpha2Code(alpha2Code: string | undefined): LocalizedCountry | undefined {
        if (alpha2Code === undefined) return undefined

        const name = getName(alpha2Code, this.currentLocaleCode, { select: 'alias' })
        if (name === undefined) return undefined

        const flagEmoji = this.emojiForCountryCode(alpha2Code)

        return {
            alpha2Code,
            title: `${flagEmoji} ${name}`,
            flagEmoji
        }
    }

    getShortListCountries(): LocalizedCountry[] {
        const allCountries = this.getAllCountries()

        const us = allCountries.find((c) => c.alpha2Code === 'US')
        const ca = allCountries.find((c) => c.alpha2Code === 'CA')
        const mx = allCountries.find((c) => c.alpha2Code === 'MX')

        const shortListCountries: LocalizedCountry[] = []

        if (us) shortListCountries.push(us)
        if (ca) shortListCountries.push(ca)
        if (mx) shortListCountries.push(mx)

        return shortListCountries
    }

    emojiForCountryCode(alpha2Code: string) {
        return alpha2Code.toUpperCase().replace(/./g, (char) => String.fromCodePoint(127397 + char.charCodeAt(0)))
    }
}

export const localizedCountries = new LocalizedCountries()
